// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2733b7b6","396":"0fa53d05","488":"0f6f66ca","667":"1f634904","857":"a2005799","977":"a15b3888"}[chunkId] + ".chunk.js";
};